import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

export function mapCommitteeFromApi(d) {
  return {
    id: d.id,
    name: d.name ?? '',
    type: d.type ?? 'permanent',
    description: d.description ?? '',
    branchId: d.companyId ? String(d.companyId) : '',
    branch: d.companyName ?? '',
    createdAt: d.createdAt ? String(d.createdAt).slice(0, 10) : '',
    isActive: !!d.isActive,
    membersCount: Number(d.membersCount ?? 0),
    chairmanName: d.chairmanName ?? '',
    members: Array.isArray(d.members)
      ? d.members.map((m) => ({
        id: m.id,
        boardMemberId: m.boardMemberId ? String(m.boardMemberId) : '',
        boardMemberName: m.boardMemberName ?? '',
        role: m.role ?? 'member',
      }))
      : [],
  };
}

export function mapCommitteeFormToPayload(form) {
  return {
    name: form.name?.trim() ?? '',
    type: form.type ?? 'permanent',
    companyId: Number(form.branchId),
    description: form.description?.trim() || null,
    createdAtUtc: form.createdAt || null,
    isActive: !!form.isActive,
    members: (form.members || []).map((m) => ({
      boardMemberId: Number(m.boardMemberId),
      role: m.role || 'member',
    })),
  };
}

export async function fetchCommittees() {
  const res = await fetch(`${API_BASE}/api/committees`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل اللجان'));
  const list = Array.isArray(data) ? data : [];
  return list.map(mapCommitteeFromApi);
}

export async function fetchCommitteeById(id) {
  const res = await fetch(`${API_BASE}/api/committees/${id}/detail`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل بيانات اللجنة'));
  return mapCommitteeFromApi(data);
}

export async function createCommittee(payload) {
  const res = await fetch(`${API_BASE}/api/committees`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إضافة اللجنة'));
  return mapCommitteeFromApi(data);
}

export async function updateCommittee(id, payload) {
  const res = await fetch(`${API_BASE}/api/committees/${id}/edit`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر حفظ تعديلات اللجنة'));
  return mapCommitteeFromApi(data);
}

export async function deleteCommittee(id) {
  const res = await fetch(`${API_BASE}/api/committees/${id}`, {
    method: 'DELETE',
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  if (res.status === 204) return;
  const data = await res.json().catch(() => ({}));
  throw new Error(messageFromErrorBody(data, 'تعذر حذف اللجنة'));
}
